import Markdown from "react-markdown";
import { safeMeetingLink } from "../lib/meetings";
/** Provider text is untrusted. No raw HTML, image requests or unsafe protocols. */
export default function MeetingMarkdown({ text }: { text: string }) {
  return (
    <Markdown
      skipHtml
      urlTransform={safeMeetingLink}
      components={{
        a: ({ href, children }) =>
          href ? (
            <a href={href} target="_blank" rel="noopener noreferrer">
              {children}
            </a>
          ) : (
            <span>{children}</span>
          ),
        img: ({ alt }) => <span>{alt}</span>,
      }}
    >
      {text}
    </Markdown>
  );
}
